import React from "react";
import { Route, Routes } from "react-router";
import Main from "@pages/Main";
import BookContainer from "@pages/BookContainer";

const AppRoutes = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/:categoryKey/:book" element={<BookContainer />} />
        <Route path="*" element={<div>없다</div>} />
      </Routes>
    </React.Fragment>
  );
};

export default AppRoutes;
